<div class="company-register-verify">
  <p-splitButton
    *ngIf="verifyMenuItems.length > 1; else plainVerifyButton"
    label="Перевірити в реєстрі"
    icon="pi pi-search"
    styleClass="p-button-secondary"
    [disabled]="!registrationCode?.trim() || loading"
    [model]="verifyMenuItems"
    (onClick)="onVerify()">
  </p-splitButton>
  <ng-template #plainVerifyButton>
    <p-button
      label="Перевірити в реєстрі"
      icon="pi pi-search"
      styleClass="p-button-secondary"
      [disabled]="!registrationCode?.trim() || loading"
      (onClick)="onVerify()">
    </p-button>
  </ng-template>

  <p-progressSpinner *ngIf="loading" styleClass="company-register-verify__spinner" strokeWidth="6"></p-progressSpinner>

  <div *ngIf="!loading && error" class="company-register-verify__error">
    Не вдалося перевірити код у зовнішньому реєстрі. Спробуйте пізніше.
  </div>

  <div *ngIf="!loading && result && !result.found && result.notFoundReason === 'access_restricted'" class="company-register-verify__restricted">
    Компанія з кодом «{{ result.registrationCode }}» існує та зареєстрована, але доступ до її даних
    обмежено в реєстрі ({{ result.provider }}) відповідно до Постанови Кабінету Міністрів України
    від 03.10.2025 № 1257 — на запит самого контрагента. Перевірте код і дані вручну.
  </div>

  <div *ngIf="!loading && result && !result.found && result.notFoundReason !== 'access_restricted'" class="company-register-verify__not-found">
    За кодом «{{ result.registrationCode }}» нічого не знайдено в реєстрі ({{ result.provider }}).
  </div>

  <p-dialog
    header="Дані з реєстру"
    [(visible)]="showResultDialog"
    [modal]="true"
    [closable]="true"
    [style]="{'width': '480px'}"
    (onHide)="onIgnore()">

    <div class="company-register-verify__found" *ngIf="result?.found">
      <div class="company-register-verify__field" *ngIf="result.officialName">
        <span class="company-register-verify__label">Повна назва:</span> {{ result.officialName }}
      </div>
      <div class="company-register-verify__field" *ngIf="result.shortName">
        <span class="company-register-verify__label">Скорочена назва:</span> {{ result.shortName }}
      </div>
      <div class="company-register-verify__field" *ngIf="result.status">
        <span class="company-register-verify__label">Статус:</span> {{ result.status }}
      </div>
      <div class="company-register-verify__field" *ngIf="result.legalAddress">
        <span class="company-register-verify__label">Адреса:</span> {{ result.legalAddress }}
      </div>
      <div class="company-register-verify__field" *ngIf="result.director">
        <span class="company-register-verify__label">Керівник:</span> {{ result.director }}
      </div>
      <div class="company-register-verify__field" *ngIf="result.registrationDate">
        <span class="company-register-verify__label">Дата реєстрації:</span> {{ result.registrationDate }}
      </div>
      <div class="company-register-verify__field" *ngIf="vatInfo?.found">
        <span class="company-register-verify__label">Платник ПДВ:</span> {{ vatInfo.vatNumber
        }}<span *ngIf="vatInfo.registrationDate"> (з {{ vatInfo.registrationDate | date:'dd.MM.yyyy' }})</span><span
        *ngIf="vatInfo.note"> — {{ vatInfo.note }}</span><span
        *ngIf="vatInfo.cancellationDate"> (скасовано {{ vatInfo.cancellationDate | date:'dd.MM.yyyy' }})</span>
      </div>
      <div class="company-register-verify__field" *ngIf="taxationMode?.found">
        <span class="company-register-verify__label">Система оподаткування:</span>
        <ng-container *ngIf="taxationMode.generalSystem === true"> загальна</ng-container>
        <ng-container *ngIf="taxationMode.singleTaxGroup != null">
          єдиний податок, гр.{{ taxationMode.singleTaxGroup
          }}<span *ngIf="taxationMode.singleTaxRate != null">, {{ taxationMode.singleTaxRate }}%</span><span
          *ngIf="taxationMode.singleTaxActive === false"> (неактивний)</span>
        </ng-container>
      </div>
      <div class="company-register-verify__source">Джерело: {{ result.provider }}</div>
    </div>

    <ng-template pTemplate="footer">
      <p-button
        label="Ігнорувати"
        [text]="true"
        severity="primary"
        (onClick)="onIgnore()">
      </p-button>
      <p-splitButton
        label="Оновити все"
        icon="pi pi-check"
        styleClass="p-button-success"
        [model]="applyMenuItems"
        (onClick)="onApply('all')">
      </p-splitButton>
    </ng-template>
  </p-dialog>
</div>
